export default {
  formId: "blogger_signup",
  splash: {
    callToAction: "Apply to become a blogger with JourneyBinder!",
    button: "Start"
  },
  questions: [
    {
      type: "splash"
    },
    {
      question: "What's your full name?",
      type: "text",
      minLength: 2
    },
    {
      question: "Which email address shall we use?",
      small: "Don't worry, we're not going to spam you.",
      type: "email"
    },
    {
      question: "Which topics do you normally write about?",
      type: "text"
    },
    {
      id: "thank-you",
      question: "Please click the button to submit your application",
      type: "submit"
    }
  ]
};
